import { gql } from '@apollo/client';

export default gql`
  fragment FullUser on User {
    stream_chat_id
    stream_chat_token
    is_primary
    id
    email
    first_name
    last_name
    position
    account_settings {
      locale
      pref_date_format
      receive_chat_messages
      receive_company_and_product_updates
      receive_job_invitation_responses
      receive_talent_join_notifications
      receive_talent_proposal_notifications
    }
    scoped_companies {
      id
      name
      logo
    }
    company {
      id
      account_type
      name
      logo
      currency
      website
      type_of_activity
      sign_up_landing_link
      country
      about
      region
      is_vonage_enabled
      is_broadbean_enabled
    }
    created_at
    updated_at
    avatar {
      avatar
      hash
    }
  }
`;
